import React, { createContext, useContext, useState } from 'react';

const NoteContext = createContext();

export const NoteProvider = ({ children }) => {
  const [noteContent, setNoteContent] = useState('');
  return (
    <NoteContext.Provider value={{ noteContent, setNoteContent }}>
      {children}
    </NoteContext.Provider>
  );
};

export const useNote = () => {
  const ctx = useContext(NoteContext);
  if (!ctx) {
    throw new Error('useNote must be used within NoteProvider');
  }
  return ctx;
};
